// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1minc","title":"InfoRow_title__34lYp"};